import _defineProperty2 from "D:\\a\\1\\s\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty2(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import _Reflect$construct from "@babel/runtime-corejs3/core-js-stable/reflect/construct";
import _extends from "@babel/runtime-corejs3/helpers/extends";
import _classCallCheck from "@babel/runtime-corejs3/helpers/classCallCheck";
import _createClass from "@babel/runtime-corejs3/helpers/createClass";
import _assertThisInitialized from "@babel/runtime-corejs3/helpers/assertThisInitialized";
import _get from "@babel/runtime-corejs3/helpers/get";
import _inherits from "@babel/runtime-corejs3/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime-corejs3/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime-corejs3/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
      result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;
      result = _Reflect$construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn(this, result);
  };
}
function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !_Reflect$construct) return false;
  if (_Reflect$construct.sham) return false;
  if (typeof Proxy === "function") return true;
  try {
    Date.prototype.toString.call(_Reflect$construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}
import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { getValueForInput } from '@jutro/data';
import { FieldComponent } from '../FieldComponent/FieldComponent';
import styles from "./InputField.module.css";
import { FieldIcon } from '../FieldComponent/FieldIcon';
import { getKeyPressHandler } from '../../../accessibility/getKeyPressHandler';
export let InputField = function (_FieldComponent) {
  _inherits(InputField, _FieldComponent);
  var _super = _createSuper(InputField);
  function InputField(..._args) {
    var _this;
    _classCallCheck(this, InputField);
    _this = _super.call(this, ..._args);
    _defineProperty(_assertThisInitialized(_this), "handleClick", getKeyPressHandler((...args) => {
      const onEnter = _this.props.onEnter;
      if (onEnter) {
        onEnter(...args);
      }
    }, ['Enter']));
    return _this;
  }
  _createClass(InputField, [{
    key: "render",
    value: function render() {
      return _get(_getPrototypeOf(InputField.prototype), "render", this).call(this);
    }
  }, {
    key: "renderControl",
    value: function renderControl(breakpointProps, options) {
      const id = breakpointProps.id,
        value = breakpointProps.value,
        maxLength = breakpointProps.maxLength,
        disabled = breakpointProps.disabled,
        editable = breakpointProps.editable,
        controlClassName = breakpointProps.controlClassName,
        required = breakpointProps.required,
        autoComplete = breakpointProps.autoComplete,
        inputType = breakpointProps.inputType;
      const focusHandlers = this.getInputFocusHandlers();
      const inputStyle = cx(styles.input, {
        disabled,
        invalid: !options.isValid
      }, controlClassName);
      return React.createElement(FieldIcon, breakpointProps, React.createElement("input", _extends({
        id: id,
        type: inputType,
        className: inputStyle,
        maxLength: maxLength,
        value: getValueForInput(inputType, value),
        onChange: this.handleChange,
        onKeyPress: this.handleClick
      }, focusHandlers, {
        disabled: disabled,
        readOnly: !editable,
        "aria-readonly": !editable,
        required: required,
        autoComplete: autoComplete ? 'on' : 'off'
      }, this.generateDataPathProperty(), this.generateAccessibilityProperties())));
    }
  }]);
  return InputField;
}(FieldComponent);
_defineProperty(InputField, "propTypes", _objectSpread({}, FieldComponent.propTypes, {
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  defaultValue: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  autoComplete: PropTypes.bool,
  maxLength: PropTypes.number
}, FieldIcon.propTypes, {
  onEnter: PropTypes.func,
  editable: PropTypes.bool
}));
_defineProperty(InputField, "defaultProps", _objectSpread({}, FieldComponent.defaultProps, {
  autoComplete: true,
  editable: true
}));
_defineProperty(InputField, "contextType", FieldComponent.contextType);
InputField.__docgenInfo = {
  componentName: "InputField",
  packageName: "@jutro/components",
  description: "Renders an input element.",
  displayName: "InputField",
  methods: [{
    name: "renderControl",
    docblock: "Render control for this component.\n\n@param {object} breakpointProps - breakpoint-specific props\n@param {object} options - rendering options (like 'isInvalid', 'isValid', etc)\n\n@returns {React.ReactElement} JSX for the control",
    modifiers: [],
    params: [{
      name: "breakpointProps",
      description: "breakpoint-specific props",
      type: {
        name: "object"
      },
      optional: false
    }, {
      name: "options",
      description: "rendering options (like 'isInvalid', 'isValid', etc)",
      type: {
        name: "object"
      },
      optional: false
    }],
    returns: {
      description: "JSX for the control",
      type: {
        name: "React.ReactElement"
      }
    },
    description: "Render control for this component."
  }],
  actualName: "InputField",
  metadataType: "field",
  props: {
    value: {
      type: {
        name: "union",
        value: [{
          name: "string"
        }, {
          name: "number"
        }]
      },
      required: false,
      description: "String or number passed as value"
    },
    defaultValue: {
      type: {
        name: "union",
        value: [{
          name: "string"
        }, {
          name: "number"
        }]
      },
      required: false,
      description: "Default value"
    },
    autoComplete: {
      type: {
        name: "bool"
      },
      required: false,
      description: "HTML5 native autoComplete support",
      defaultValue: {
        value: "true",
        computed: false
      }
    },
    maxLength: {
      type: {
        name: "number"
      },
      required: false,
      description: "Max length for the input field"
    },
    onEnter: {
      type: {
        name: "func"
      },
      required: false,
      description: "Callback to call on enter key press"
    },
    editable: {
      type: {
        name: "bool"
      },
      required: false,
      description: "If set to false the input field is read-only but user can tab to it, highlight it, and copy the text from it",
      defaultValue: {
        value: "true",
        computed: false
      }
    }
  },
  composes: ["../FieldComponent/FieldComponent", "../FieldComponent/FieldIcon"]
};